export default {
  name: 'spec-note-comp',
  data() {
    return {
      bannerList: [
        {
          "photo": "/img/maanam.png",
          "link": "/topspecjalny/maanam"
        },
        {
          "photo": "/img/adams.png",
          "link": "/topspecjalny/bryanadams"
        },
        {
          "photo": "/img/cure.png",
          "link": "/topspecjalny/thecure"
        },
        {
          "photo": "/img/bowie.png",
          "link": "/topspecjalny/davidbowie"
        }
      ]
    }
  }
}
